module.exports = __webpack_public_path__ + "assets/img/download5.5bf6b864.jpg";